import React, { Component } from "react";
import { Link, browserHistory } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import I18n from "lib/i18n/i18n";
import Validators from "lib/validators";
import LoginWithGoogle from "./login/LoginWithGoogle";
import GA from "lib/ga";
import WorthyApiErrors, { WORTHY_API_ERRORS } from "lib/api/worthyApiErrors";
import { imageUrl, rootUrl, submissionFlowUrl } from 'helpers/ApplicationHelper';
import { InputText, InputEmail, InputTel } from "components/formElements";
import SellItemWizard from "components/sellItemWizard";
import ReactScroll from "react-scroll";
import { performRegister } from "actions/register";
import { needsEstimation, generateEstimation } from "actions/item";
import { newPendingItem, updateReferrer } from "actions/pendingItem";
import { updateSubmissionProgressState } from "actions/submissionProgress";
import { createPendingJewelryBox } from "actions/pendingJewelryBox";
import { widgetEventDispatcher, isMobile } from "helpers/ApplicationHelper";
import UserActions from "lib/userActions";
import { RadioGroup, Radio, MediumPrimaryButton } from "@worthy-npm/clarity";
import { Divider } from "@material-ui/core";
import SurveyWrap from "components/surveyWrap";
import { DEFAULT_PHONE } from "../constants/register";

class Register extends Component {
  // worthy-9028 - when we want to redirect to site after item submission - we need to know not to redirect to app home.
  pendingRedirect = false;

  constructor(props) {
    super(props);
    this.state = {
      referrer: this.props.pendingItem
        ? this.props.pendingItem.referrer
        : undefined,
      pendingItem: this.props.pendingItem
        ? this.props.pendingItem.item
        : undefined,
      pendingJewelryBox: this.props.pendingJewelryBox
        ? this.props.pendingJewelryBox
        : undefined,
      formSubmitted: false,
      forcePhoneField: true,
    };
    if (props.item && typeof props.item.forcePhoneField !== "undefined") {
      this.state.forcePhoneField = props.item.forcePhoneField;
    }

    this.contact_preference = React.createRef();
    this.phoneVariantWrapRef = React.createRef();
    this.isMobile = isMobile();
  }

  componentWillReceiveProps({
    Session,
    register,
    jewelryBox,
    Experiments,
    item,
  }) {
    if (Session && !Session.isLoggedIn && register instanceof WorthyApiErrors) {
      this.setState({ formSubmitted: false });
      let error = register;
      if (error.hasError(WORTHY_API_ERRORS.EMAIL_TAKEN)) {
        this._email.setError(error.toString());
      } else {
        this._email.setWordlessError();
        this._phone.setError(error.toString());
      }
    } else {
      if (Session && Session.isLoggedIn && Experiments) {
        if (
          (Experiments?.online_survey?.variant === "true" ||
            Experiments?.get_estimate_exp?.variant === "true") &&
          (item || jewelryBox || this.props.location.query.bundle)
        ) {
          this.setState({ showSurvey: true });
        } else {
          this.setState({ continueWithRegistration: true }, this.afterRegister);
        }
      }
    }
    if (item && this.state.forcePhoneField !== item.forcePhoneField) {
      this.setState({ forcePhoneField: item.forcePhoneField });
    }
  }

  beforeRegister() {
    this.setState({ formSubmitted: true });
    let label = this.state.pendingJewelryBox
      ? "jewelryBox"
      : this.state.pendingItem
      ? this.state.pendingItem["item_type"]
      : undefined;
    console.time("register");
    GA.registartionFormClicked();
    return label;
  }

  afterRegister() {
    const { pendingItem, item, jewelryBox, location, register } = this.props;
    const bundleId = this.props.location.query.bundle;
    if (this.state.continueWithRegistration) {
      if (pendingItem && item) {
        // on register, num of past items = 0
        GA.itemSubmissionSuccessfully();
        browserHistory.push(`/item/${item.id}`);
        this.pendingRedirect = true;
      } else if (jewelryBox || bundleId) {
        window.location.pathname = `/multiple_jewelry/${
          bundleId || jewelryBox.bundle_id
        }`;
        this.pendingRedirect = true;
      } else if (location && location.state && location.state.redirectTo) {
        window.location = rootUrl(location.state.redirectTo);
      } else if (
        (!pendingItem || !item) &&
        !jewelryBox &&
        !this.pendingRedirect
      ) {
        window.location.href = submissionFlowUrl('');
      }
    }
  }

  componentDidMount() {
    this.props.updateSubmissionProgressState("registration form");

    let label = "Else";
    if (this.state.pendingItem) {
      label = this.state.pendingItem["item_type"];
    } else if (this.state.pendingJewelryBox) {
      label = " Jewelry box";
    }
    GA.logItemTypeVariable(label); //todo: remove when 10156 last name exp ends.
    if (!this.state.funnelStepEventFired) {
      GA.registartionFormViewed();
      this.setState({ funnelStepEventFired: true });
    }
    this._mounted = true;

    let fbA = document.querySelector(".fb-a-test");
    let isAtest = window.getComputedStyle(fbA).display !== "none";
    this._email = isAtest ? this.refs["email"] : this.refs["email-b"];
    this._phone = isAtest ? this.refs["phone"] : this.refs["phone-b"];
    this._firstName = isAtest
      ? this.refs["firstName"]
      : this.refs["firstName-b"];
    this._lastName = isAtest ? this.refs["lastName"] : this.refs["lastName-b"];
    this._fullName = isAtest ? this.refs["fullName"] : this.refs["fullName-b"];

    ReactScroll.animateScroll.scrollTo(0, {
      duration: 0,
      delay: 0,
      smooth: true,
    });
    widgetEventDispatcher("registration-form-rendered");
  }

  componentWillUnmount() {
    this.props.updateSubmissionProgressState();
    this._mounted = false;
    if (this.props.pendingItem) {
      this.props.updateReferrer("registerForm");
    }
  }

  _validateFirstName = () => {
    this._firstName.clearErrors();
    if (Validators.validateName(this._firstName.state.value)) {
      return Promise.resolve();
    } else {
      this._firstName.setError(
        I18n.getString("registerPage::form::errors::emptyFirstName")
      );
      return Promise.reject();
    }
  };

  _validateFullName = () => {
    this._fullName.clearErrors();
    if (Validators.validateName(this._fullName.state.value)) {
      return Promise.resolve();
    } else {
      this._fullName.setError(
        I18n.getString("registerPage::form::errors::emptyFullName")
      );
      return Promise.reject();
    }
  };

  _validateLastName = () => {
    this._lastName.clearErrors();

    if (Validators.validateName(this._lastName.state.value)) {
      return Promise.resolve();
    } else {
      this._lastName.setError(
        I18n.getString("registerPage::form::errors::emptyLastName")
      );
      return Promise.reject();
    }
  };

  _validateEmail = () => {
    this._email.clearErrors();
    if (Validators.validateEmail(this._email.state.value)) {
      return Promise.resolve();
    } else {
      const proper_error_message =
        this._email.state.value.length === 0
          ? "registerPage::form::errors::emptyEmail"
          : "registerPage::form::errors::email";
      this._email.setError(I18n.getString(proper_error_message));
      return Promise.reject();
    }
  };

  _validatePhone = () => {
    // if no mandatory phone - resolve for empty phone number.
    if (!this.state.forcePhoneField) {
      if (this._phone.state.value === "") {
        this._phone.clearErrors();
        return Promise.resolve();
      }
    }
    this._phone.clearErrors();
    if (Validators.validatePhone(this._phone.state.value)) {
      return Promise.resolve();
    } else {
      const proper_error_message =
        this._phone.state.value.length === 0
          ? "registerPage::form::errors::emptyPhone"
          : "registerPage::form::errors::phone";
      this._phone.setError(I18n.getString(proper_error_message));
      return Promise.reject();
    }
  };

  _validate() {
    //todo: remove when 10298 exp is done. this was done to detect variant of exp to prevent failures on registration. after removing, leave only the else scope.
    let fullNameFieldElement = document.getElementsByClassName("full-name")[0];
    if (fullNameFieldElement.getBoundingClientRect().top != 0) {
      return Promise.all([
        this._fullName.props.validator(),
        this._email.props.validator(),
        this._phone.props.validator(),
      ]);
    } else {
      return Promise.all([
        this._firstName.props.validator(),
        this._lastName.props.validator(),
        this._email.props.validator(),
        this._phone.props.validator(),
      ]);
    }
  }

  _getGAEventValue(value) {
    return value || "empty";
  }

  disableFields = (disable) => {
    document.querySelectorAll("form input, form button").forEach((el) => {
      el.style.pointerEvnts = disable ? "none" : "visible";
      el.disabled = !!disable;
    });
    this.setState({ disabledFields: disable });
  };

  _onFormSubmit = (event) => {
    this._onSubmit(event);
  };

  beforeRegisterWithGoogle = () => {
    if (this.state.formSubmitted) return;
    this.beforeRegister();
  };

  onRegisterSuccessWithGoogle = (response) => {
    GA.registerWithGoogleSuccessfully();
    this.onRegisterSuccess(response);
    this.setState({ continueWithRegistration: true }, this.afterRegister);
  };

  onLoginSuccessWithGoogle = () => {
    GA.loginWithGoogleSuccessfully();
    this.setState({ continueWithRegistration: true }, this.afterRegister);
  };

  onRegisterSuccess = (response) => {
    GA.registerFormSuccessfully();

    // WORTHY-12168 performance 'hack' - call generate estimation immediately for relevant items.
    if (this.props.item && needsEstimation(this.props.item)) {
      this.props.generateEstimation(this.props.item.id);
    }
  };

  isContactPreferenceDisplayed = () =>
    typeof document !== "undefined" &&
    document.querySelector("#contact-options")?.getClientRects().length;

  _onSubmit = (event) => {
    event.preventDefault && event.preventDefault();
    if (this.state.formSubmitted) return;

    this._firstName.clearErrors();
    this._fullName.clearErrors();
    this._lastName.clearErrors();
    this._email.clearErrors();
    this._phone.clearErrors();

    this._validate()
      .then(() => {
        this.beforeRegister();
        const res = performRegister({
          first_name: this._firstName.state.value || this._fullName.state.value,
          last_name: this._lastName.state.value,
          email: this._email.state.value,
          phone: this._phone.state.value || DEFAULT_PHONE,
          contact_preference: this.isContactPreferenceDisplayed()
            ? this.contact_preference.current.state.value
            : "",
          bundle_id: this.props.item?.bundle?.id,
          user_flow: this.props.userFlow,
          bundleType: this.state.pendingJewelryBox ? "jewelryBox" : "standard",
          itemType: this.state.pendingItem
            ? this.state.pendingItem["item_type"]
            : undefined,
          optionalPhoneExp: !this.state.forcePhoneField,
        });
        res.payload
          .then((response) => this.onRegisterSuccess(response))
          .catch((error) => {
            //this case is relevant if event is stopAnimation and not the html default click event
            if (typeof event == "function") {
              event();
            }
            this.setState({ formSubmitted: false });
            this._email.setError(error.toString());
          });
      })
      .catch(() => {
        //this case is relevant if event is stopAnimation and not the html default click event
        if (typeof event == "function") {
          event();
        }
        widgetEventDispatcher("registration-fields-error");
      });
  };

  onFocusPhone() {
    this.triggerShowHelper.bind(this);
  }

  renderWizard = () => {
    if (this.state.pendingItem) {
      return <SellItemWizard step={2} />;
    }
  };

  renderTitle() {
    return (
      <div>
        <h1
          className="title-A"
          dangerouslySetInnerHTML={{
            __html: I18n.getString("registerPage::title"),
          }}
        >
          {}
        </h1>
      </div>
    );
  }

  loginEventDispatcher() {
    widgetEventDispatcher("sign-in-clicked");
  }

  triggerHideHelper() {
    this.refs.phone.toggleHelper(false);
  }

  triggerShowHelper() {
    this.refs.phone.toggleHelper(true);
  }

  setTitleMobile = (title) => {
    this.setState({ surveyTitle: title });
  };

  renderSurvey() {
    const { showSurvey, surveyTitle } = this.state;
    const { item, jewelryBox, Experiments } = this.props;
    const bundleId = this.props.location.query.bundle;
    if (item || jewelryBox || (showSurvey && bundleId)) {
      const ObjectId = item ? item.id : bundleId || jewelryBox.bundle_id;
      const ObjectType = item ? "Item" : "Bundle";
      // FIXME: `get_estimate_exp` is off, should be removed
      // const surveyToShow = Experiments && Experiments.get_estimate_exp && Experiments.get_estimate_exp.variant === 'true' ? 'estimateFlow' : 'default'
      const surveyToShow = "default";
      const showThankYouExp =
        Experiments?.low_intent_survey?.variant === "true";
      return (
        <div>
          {showSurvey ? (
            <SurveyWrap
              title={
                surveyTitle || I18n.getString(`survey::${surveyToShow}::title`)
              }
              ObjectId={ObjectId}
              ObjectType={ObjectType}
              setTitleMobile={this.setTitleMobile}
              surveyTitle={surveyTitle}
              surveyToShow={surveyToShow}
              showThankYouExp={showThankYouExp && surveyToShow === "default"}
              onSurveyClose={() => {
                UserActions.survey(
                  "Survey modal closed",
                  ObjectId,
                  ObjectType,
                  "",
                  surveyToShow
                );
                this.setState(
                  { showSurvey: false, continueWithRegistration: true },
                  this.afterRegister
                );
              }}
            />
          ) : null}
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const bundleId =
      this.props &&
      this.props.location &&
      this.props.location.query &&
      this.props.location.query.bundle;

    return (
      <div>
        {this.renderWizard()}
        <div id="registerContainerA" className="register-container fb-a-test">
          {this.renderTitle()}
          {false && (
            <LoginWithGoogle
              isRegister="true"
              params={{
                contact_preference: this.isContactPreferenceDisplayed()
                  ? this.contact_preference.current.state.value
                  : "",
                bundle_id: this.props.item?.bundle?.id,
                user_flow: this.props.userFlow,
                bundleType: this.state.pendingJewelryBox
                  ? "jewelryBox"
                  : "standard",
                itemType: this.state.pendingItem
                  ? this.state.pendingItem["item_type"]
                  : undefined,
                optionalPhoneExp: !this.state.forcePhoneField,
              }}
              before={this.beforeRegister.bind(this)}
              onSuccessfulRegister={this.onRegisterSuccessWithGoogle.bind(this)}
              onSuccessfulLogin={this.onLoginSuccessWithGoogle.bind(this)}
            />
          )}
          <div className="register-container-form">
            <form onSubmit={this._onFormSubmit} noValidate>
              <div className="hidden-form-elements">
                <InputText
                  ref="firstName"
                  name="firstName"
                  inputId="register-first-name-input"
                  validator={this._validateFirstName}
                  maxLength="50"
                  inputProps={{
                    autoFocus: false,
                    autoComplete: "given-name",
                    placeholder: I18n.getString(
                      "registerPage::form::firstName::placeholder"
                    ),
                  }}
                />
                <InputText
                  ref="lastName"
                  name="lastName"
                  inputId="register-last-name-input"
                  validator={this._validateLastName}
                  maxLength="50"
                  inputProps={{
                    autoFocus: false,
                    autoComplete: "family-name",
                    placeholder: I18n.getString(
                      "registerPage::form::lastName::placeholder"
                    ),
                  }}
                />
                <InputText
                  ref="fullName"
                  name="fullName"
                  inputId="register-full-name-input"
                  validator={this._validateFullName}
                  maxLength="50"
                  className="full-name"
                  inputProps={{
                    autoFocus: false,
                    autoComplete: "family-name",
                    placeholder: I18n.getString(
                      "registerPage::form::fullName::placeholder"
                    ),
                  }}
                />
              </div>
              <InputEmail
                ref="email"
                name="email"
                className="fade"
                inputId="register-email-input"
                inputProps={{
                  autoComplete: "email",
                  autoFocus: false,
                  placeholder: I18n.getString(
                    "registerPage::form::email::placeholder"
                  ),
                }}
                validator={this._validateEmail}
              />
              <Divider className={"divider"} style={{ display: "none" }} />
              <span style={{ display: "none" }}>
                {I18n.getString("registerPage::contactPreferenceText")}
              </span>
              <RadioGroup
                name={"contact_preference"}
                ref={this.contact_preference}
                initialValue={"phone_call"}
              >
                <div id={"contact-options"}>
                  <div style={{ display: "inline-block" }}>
                    <Radio label={"Phone call"} value={"phone_call"} />
                  </div>
                  <div style={{ display: "inline-block", paddingLeft: "40px" }}>
                    <Radio label={"Text message"} value={"text_message"} />
                  </div>
                </div>
              </RadioGroup>

              <div style={{ position: "relative" }}>
                <InputTel
                  ref="phone"
                  name="phone"
                  inputId="register-phone-input"
                  textHelper={I18n.getString(
                    "registerPage::form::phone::textHelper"
                  )}
                  inputProps={{
                    autoComplete: "tel",
                    placeholder: I18n.getString(
                      "registerPage::form::phone::placeholder"
                    ),
                    onFocus: this.onFocusPhone.bind(this),
                    onBlur: this.triggerHideHelper.bind(this),
                  }}
                  validator={this._validatePhone}
                />
                {this.state.forcePhoneField === false && (
                  <span className={"phone-optional"}>
                    {I18n.getString("registerPage::form::phone::label")}
                  </span>
                )}
              </div>
              <button type="submit" hidden></button>
            </form>
            <div>
              <MediumPrimaryButton
                click={(stopAnimation) => {
                  this._onSubmit(stopAnimation);
                }}
                text={I18n.getString("registerPage::form::submitButton")}
                overrideWrapperCSS={{ width: "100%" }}
                overrideCSS={{
                  backgroundColor: "#2D5DEC",
                  borderRadius: "3px",
                  width: "100%",
                  padding: "11px 22px 12px",
                  font: "500 16px Roboto",
                  marginTop: "12px",
                  textTransform: "none",
                }}
              />
            </div>
            {this.renderSurvey()}
          </div>
          <div className="bottom">
            <div className="text">
              {I18n.getJsx("registerPage::switchToSignIn", {
                register: (
                  <Link
                    onClick={this.loginEventDispatcher}
                    className="blue"
                    to={{
                      pathname: "/signin",
                      search: `${bundleId ? `?bundle=${bundleId}` : ""}`,
                      state: {
                        redirectTo:
                          this.props.redirectTo ||
                          (this.props.location &&
                            this.props.location.state &&
                            this.props.location.state.redirectTo),
                      },
                    }}
                  >
                    {I18n.getString("registerPage::signIn")}
                  </Link>
                ),
              })}
            </div>
            <div className="logos">
              <img src={imageUrl("common/bbb.png")} alt="BBB" />
              <img
                src={imageUrl("common/secured_registration.png")}
                alt={"Secured registration"}
              />
            </div>
            <div className="new-here">
              {I18n.getJsx("registerPage::bottomText", {
                tndText: (
                  <a
                    className="blue"
                    href={`${rootUrl()}/about/terms-and-conditions`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {I18n.getString("registerPage::tndText")}
                  </a>
                ),
                privacyPolicyText: (
                    <a
                        className="blue"
                        href={`${rootUrl()}/about/privacy-policy`}
                        target="_blank"
                        rel="noreferrer"
                    >
                      {I18n.getString("registerPage::privacyPolicyText")}
                    </a>
                ),
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  Session,
  Register,
  PendingItem,
  PendingJewelryBox,
  Item,
  JewelryBox,
  UserFlow,
  Experiments,
}) => {
  return {
    Session,
    register: Register,
    pendingItem: PendingItem,
    pendingJewelryBox: PendingJewelryBox,
    item: Item,
    jewelryBox: JewelryBox,
    userFlow: UserFlow,
    Experiments,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      newPendingItem,
      updateReferrer,
      updateSubmissionProgressState,
      createPendingJewelryBox,
      generateEstimation,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
